/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/virtual_scrolling.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    dataSourceAdapterExtender,
    virtualScrollingModule
} from "../../../grids/grid_core/virtual_scrolling/m_virtual_scrolling";
import gridCore from "../m_core";
import dataSourceAdapterProvider from "../m_data_source_adapter";
gridCore.registerModule("virtualScrolling", virtualScrollingModule);
dataSourceAdapterProvider.extend(dataSourceAdapterExtender);
